export default function Cta() {
  return (
    <section className="py-20 md:py-28 relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20abstract%20soft%20mint%20green%20and%20cream%20gradient%20background%20with%20delicate%20organic%20watercolor%20textures%20and%20subtle%20paper%20grain%2C%20editorial%20wellness%20aesthetic%2C%20natural%20light%20soft%20highlights%2C%20clean%20minimalist%20composition%2C%20contemporary%20healthcare%20branding%2C%20airy%20and%20serene%20mood%20with%20blurred%20botanical%20shapes%20in%20the%20distance&width=1920&height=900&seq=medicaclic-cta-01&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-secondary-900/85 via-primary-900/75 to-secondary-900/85" />

      <div className="relative px-4 md:px-8 lg:px-12 max-w-5xl mx-auto text-center">
        <h2 className="font-heading text-3xl md:text-5xl lg:text-6xl font-semibold text-background-50 leading-tight mb-5">
          Prêt à retrouver du temps<br />
          <span className="italic text-primary-300">pour ce qui compte ?</span>
        </h2>
        <p className="text-background-100 text-base md:text-lg max-w-2xl mx-auto mb-9 leading-relaxed">
          Trouvez un praticien près de chez vous à Rabat en moins de 60 secondes.
          Gratuit, sans compte pour chercher, confirmation immédiate.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="#recherche"
            className="w-full sm:w-auto px-7 py-3.5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
          >
            <i className="ri-search-line w-4 h-4 flex items-center justify-center" />
            Chercher un praticien
          </a>
          <a
            href="#praticiens"
            className="w-full sm:w-auto px-7 py-3.5 rounded-md bg-background-50/10 hover:bg-background-50/20 backdrop-blur-sm border border-background-50/30 text-background-50 text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
          >
            <i className="ri-stethoscope-line w-4 h-4 flex items-center justify-center" />
            Je suis praticien
          </a>
        </div>
      </div>
    </section>
  );
}